// Registers the PWA service worker (`public/sw.js`). Called from main.tsx in
// production builds only. The service worker provides offline caching, the
// home-screen install, and is the registration Firebase Cloud Messaging uses
// for push notifications.
export function registerServiceWorker(): void {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/sw.js')
        .then(registration => {
          console.log(
            'Service Worker registered with scope:',
            registration.scope
          )
        })
        .catch(error => {
          console.error('Service Worker registration failed:', error)
        })
    })
  }
}

// Logs when the browser offers a home-screen install and when it completes.
export function checkInstallability(): void {
  window.addEventListener('beforeinstallprompt', e => {
    // Prevent the mini-infobar from appearing on mobile
    e.preventDefault()
    console.log('App can be installed')
  })

  window.addEventListener('appinstalled', () => {
    console.log('App was installed')
  })
}
